import { ProtectedRoute } from '../component/util/protected-route'
import { AuthCallbackScreen } from './auth-callback-screen'
import { HomeScreen } from './home-screen'
import { LegalAgreementScreen } from './legal-agreement-screen'
import { PrivacyPolicyScreen } from './legal/privacy-policy-screen'
import { TermsAndConditionsScreen } from './legal/terms-and-conditions-screen'
import { LogoutScreen } from './logut-screen'
import { CreateAccountScreen } from './public/create-account-screen'
import { ForgotPasswordScreen } from './public/forgot-password-screen'
import { ImportWelcomeScreen } from './public/import-welcome-screen'
import { LoginScreen } from './public/login-screen'
import { VerifyEmailScreen } from './public/verify-email-screen'
import { Redirect, Route, Switch } from 'react-router-dom'

export const Router = (): React.ReactElement => {
  return (
    <Switch>
      <Route path="/code/callback" component={AuthCallbackScreen} />
      <Route exact path="/login" component={LoginScreen} />
      <Route path="/create-account/" component={CreateAccountScreen} />
      <Route exact path="/verify-email/:verifyEmailCode" component={VerifyEmailScreen} />
      <Route path="/forgot-password" component={ForgotPasswordScreen} />
      <Route path="/import-welcome/:email" component={ImportWelcomeScreen} />
      <Route path="/legal/terms-and-conditions" component={TermsAndConditionsScreen} />
      <Route path="/legal/privacy-policy" component={PrivacyPolicyScreen} />
      <ProtectedRoute exact path="/" component={HomeScreen} />
      <ProtectedRoute exact path="/logout" component={LogoutScreen} />
      <ProtectedRoute exact path="/legal-agreement" component={LegalAgreementScreen} />
      <Redirect to="/" />
    </Switch>
  )
}
